import { render, staticRenderFns } from "./page3-xiyatu.vue?vue&type=template&id=3f000f3f&scoped=true"
import script from "./page3-xiyatu.vue?vue&type=script&lang=js"
export * from "./page3-xiyatu.vue?vue&type=script&lang=js"
import style0 from "./page3-xiyatu.vue?vue&type=style&index=0&id=3f000f3f&prod&scoped=true&lang=css"
import style1 from "./page3-xiyatu.vue?vue&type=style&index=1&id=3f000f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f000f3f",
  null
  
)

export default component.exports